var _defs, _polygon, _rect, _path, _polyline, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntrada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffffff;stroke-miterlimit:10;stroke-width:1.91px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.63 22.5 1.5 22.5 1.5 3.5 11.63 1.5 11.63 22.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.63,
    y: 3.5,
    width: 3.65,
    height: 19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.8,11.5h0Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "19.85 15.5 17.13 12.53 19.85 9.55"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.5,
    y1: 12.5,
    x2: 17.11,
    y2: 12.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrada);
export default __webpack_public_path__ + "static/media/entrada.d1f01bab2a487ed07506547c4d09512f.svg";
export { ForwardRef as ReactComponent };